import React, { useEffect, useState } from "react";
import Image from "../../components/ui/image";
import { Images } from "../../lib/images";
import { getTopClubs, refershTitenIndex } from "../../Services/apis";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Current() {
  const[topClubs, setTopClubs] = useState<any>([]);
  const[loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const GetTopClubs = async () => {
    try {
      setLoading(true);
  const data = await getTopClubs();
   console.log("Top Clubs Data:", data);
   setTopClubs(data?.top3);
    setLoading(false);
} catch (error) {
    setLoading(false);
  console.error("Failed to fetch top clubs:", error);
}
  }
useEffect(() => {
    GetTopClubs();
  }
  , []);
   const RefreshTitenIndex = async () => {
    try {
      setLoading(true);
  const data = await refershTitenIndex();
   console.log("Top Clubs Data:", data);
     if (data.success) {
     toast.success(data?.message);
     GetTopClubs();
    setLoading(false);
     }
   else { 
      toast.error(data?.message);
      setLoading(false);
     }
} catch (error) {
    setLoading(false);
  console.error("Failed to fetch top clubs:", error);
}
  }
  return (
    <section className="px-5 bg-gradient-to-r from-[#8c2720] via-[#522522] to-[#0086D6] relative">
    {loading&&<Loader/>  }
      <div className="container mx-auto pt-20 pb-5">
        <h2 className="headingB pb-1 !text-white text-center lg:text-left">
          Current Top 3
        </h2>
        <div className="flex lg:flex-row flex-col gap-5 items-center justify-between">
          <p className="commonTxt !text-white text-center">
            The highest-ranking clubs according to the Titan Index
          </p>
          {/* <div> */}
           {/* <button
          className="blueButton mr-2 uppercase"
          onClick={() =>  RefreshTitenIndex()}
        >
          Refresh Titen Index
        </button> */}
          <button className="redButton" onClick={()=>navigate('/league-table')} >View League Table</button>
        {/* </div> */}
        </div>
        <div className="grid grid-cols-3 gap-5 pt-8">
          {topClubs && topClubs.map((club:any, index:number) => (
          <div key={club?.club_id || club?.rank || index} className="col-span-3 md:col-span-1 bg-white rounded-xl p-5">
            <div className="flex items-center justify-between">
              <span className="inline-block border border-redBtn rounded-full px-2 py-1 text-base font-medium text-redBtn">
                <Image src={Images.Cup} alt="" className="inline me-1 w-4" />
                #{club?.rank}
              </span>
              <Image
                src={club?.logo_url || Images.Image}
                alt={club?.club || "No Image"}
                className="w-10 h-10 object-contain"
                width={40}
                height={40}
                fallbackSrc={Images.Image}
              />
            </div>
            <h5 className="text-base font-medium text-black pt-3">
              {club.club}
            </h5>
            <p className="text-sm text-greyColor">{club?.country}</p>
            <div className="flex items-center justify-between pt-5">
              <span className="font-medium text-sm text-black">
                Titan Score
              </span>
              <span className="font-bold text-lg">{club?.titan_score}</span>
            </div>
          </div>
          ))}
          {/* <div className="col-span-3 md:col-span-1 bg-white rounded-xl p-5">
            <span className="inline-block border border-redBtn rounded-full px-2 text-sm font-medium text-redBtn">
              #2
            </span>
            <h5 className="text-base font-medium text-black pt-3">
              Aston Villa FC
            </h5>
            <p className="text-sm text-greyColor">England</p>
            <div className="flex items-center justify-between pt-5">
              <span className="font-medium text-sm text-black">
                Titan Score
              </span>
              <span className="font-bold text-lg">97.5</span>
            </div>
          </div>
          <div className="col-span-3 md:col-span-1 bg-white rounded-xl p-5">
            <span className="inline-block border border-redBtn rounded-full px-2 text-sm font-medium text-redBtn">
              #3
            </span>
            <h5 className="text-base font-medium text-black pt-3">
              AFC Bournemouth
            </h5>
            <p className="text-sm text-greyColor">England</p>
            <div className="flex items-center justify-between pt-5">
              <span className="font-medium text-sm text-black">
                Titan Score
              </span>
              <span className="font-bold text-lg">95.5</span>
            </div>
          </div> */}
        </div>
      </div>
      <div className="text-right -mr-5">
        <Image src={Images.Curve} alt="" className="inline" />
      </div>
    </section>
  );
}

export default Current;
